import { useToast } from '@chakra-ui/react';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import outstandingDebtDataTableRowFormMeta from '../../../formHandler/cardData/customerDetail/OustandingDebt/OutstandingDebtDataTableRowFormMeta';
import {
  getOutstandingDebtDataTableColumns,
  TOutstandingDebtDataTableData,
} from './OutstandingDebtDataTableMeta';
import OutstandingDebtDataTableRowFormUI from '../../../../components/forms/cardData/customerDetail/OustandingDebtDataTableRowFormUI';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

const OutstandingDebtDataTableHandler = ({
  customerId,
}: {
  customerId: string | number,
}) => {
  const [rowDataTable, setRowDataTable] =
    React.useState<TOutstandingDebtDataTableData>({
      primaryKey: '',
      creditor: '',
      account: '',
      accountHolderName: '',
      initialAmount: 0,
      currentBalance: 0,
      monthlyPay: 0,
    });

  const editModalRef = React.useRef<any>(null);

  const formModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null);

  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['OutstandingDebt'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve([{}, {}, {}]), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
            await mutateAsync();
        } catch (error) {
            console.log(error);
        }*/
  };

  const handleEdit = (row: any) => {
    setRowDataTable(row.original);

    editModalRef?.current?.onOpen();
  };

  const columns = getOutstandingDebtDataTableColumns({
    isLoading,
    handleEdit,
  });

  const triggerSubmit = () => {
    formModalRef?.current?.submitBtnRef?.current?.click();
  };

  const onModalFormSubmit = async (payload: any) => {
    console.log('Modal payload: ', payload);
  };

  return (
    <>
      <CC.Flex
        my={3}
        justifyContent={{ md: 'flex-end' }}
        direction={{ base: "column", md: "row"}}
        gap={'5'}
      >
        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Total Montant Inital</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'3xl'}>
            0000
          </CC.Text>
        </CC.Box>
        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Total Solde Courant</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'3xl'}>
            0000
          </CC.Text>
        </CC.Box>
        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Total Paiements mensuels</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'3xl'}>
            0000
          </CC.Text>
        </CC.Box>
      </CC.Flex>

      <CustomReactTable data={data || [{}, {}]} columns={columns} />

      <CustomAppModal
        title="Editer"
        ref={editModalRef}
        actionBtn={
          <CustomSaveBtn
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            onClick={triggerSubmit}
          />
        }
        actionBtnText={'Valider'}
        size="3xl"
        isCentered
        closeOnOverlayClick={false}
      >
        <OutstandingDebtDataTableRowFormUI
          data={rowDataTable}
          meta={outstandingDebtDataTableRowFormMeta}
          onSubmit={onModalFormSubmit}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          ref={formModalRef}
        />
      </CustomAppModal>
    </>
  );
};

export default OutstandingDebtDataTableHandler;
